export enum FacetType {
	Checkbox = 'checkbox',
	NestedCheckbox = 'nestedcheckbox',
	Link = 'link',
	Nestedlink = 'nestedlink',
	Slider = 'slider',
	Swatch = 'swatch',
	Rating = 'rating',
	Size = 'size',
	SearchWithin = 'search',
	RecentSearches = 'recentsearches',
	RelatedSearches = 'relatedsearches',
	OpenRange = 'openRange',
}
